import React from 'react';
import Link from '@/components/ui/Link';
import { withRef } from '@/lib/with-ref';
import Button from '../Root';
import type { LinkButtonElement, LinkButtonProps } from './types';

const ButtonLink = withRef<LinkButtonElement, LinkButtonProps>(
  ({ href, linkProps = {}, children, ...props }, ref) => {
    return (
      <Button asChild={true} {...props}>
        <Link href={href} {...linkProps}>
          {children}
        </Link>
      </Button>
    );
  },
);

export default React.memo(ButtonLink);
